import './diningOption.scss';

export const DiningOptionComponent = {
    template: `
        <p>Please select an order type</p>

        <form class="radio-group">
            <input class="ordertype"
                   type="radio"
                   id="takeout"
                   name="order"
                   value="pickup"
                   ng-if="$ctrl.data.diningOptions.hasTakeout || !$ctrl.data.diningOptions.hasDelivery"
                   ng-checked="$ctrl.data.diningOption === $ctrl.DINING_OPTION.TAKE_OUT"/>
            <label for="takeout"
                   class="PICKUP"
                   ng-if="$ctrl.data.diningOptions.hasTakeout || !$ctrl.data.diningOptions.hasDelivery"
                   ng-click="$ctrl.pickTakeout()">
                Pickup
            </label>

            <input class="ordertype"
                   type="radio"
                   id="delivery"
                   name="order"
                   value="delivery"
                   ng-if="$ctrl.data.diningOptions.hasDelivery || !$ctrl.data.diningOptions.hasTakeout"
                   ng-checked="$ctrl.data.diningOption === $ctrl.DINING_OPTION.DELIVERY"/>
            <label for="delivery"
                   class="DELIVERY"
                   ng-if="$ctrl.data.diningOptions.hasDelivery || !$ctrl.data.diningOptions.hasTakeout"
                   ng-click="$ctrl.pickDelivery()">
                Delivery
            </label>
        </form>
    `,
    controller: function DiningOptionController(consumerService, localStorageService, restaurantService, DINING_OPTION) {
        'ngInject';
        const ctrl = this;
        ctrl.data = consumerService.data;
        ctrl.data.diningOptions = restaurantService.data.diningOptions;
        ctrl.DINING_OPTION = DINING_OPTION;
        ctrl.pickDelivery = pickDelivery;
        ctrl.pickTakeout = pickTakeout;

        _activate();

        function pickDelivery() {
            _diningOptionSelected(DINING_OPTION.DELIVERY);
        }

        function pickTakeout() {
            _diningOptionSelected(DINING_OPTION.TAKE_OUT);
        }

        function _activate() {
            var diningOption;

            if (ctrl.data.diningOptions && !ctrl.data.diningOptions.hasDelivery) {
                diningOption = DINING_OPTION.TAKE_OUT;
            } else if (ctrl.data.diningOptions && !ctrl.data.diningOptions.hasTakeout) {
                diningOption = DINING_OPTION.DELIVERY;
            } else {
                diningOption = consumerService.getDiningOption();
            }

            ctrl.data.diningOption = diningOption;
        }

        function _clearRestaurantData() {
            restaurantService.clearNearbyRestaurants();
        }

        function _diningOptionSelected(diningOption) {
            consumerService.setDiningOption(diningOption);

            _clearRestaurantData();
        }
    }
};
